exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".free-shipping-notice[data-v-0ae98987]{align-items:center;background:#f3f8ff;border:1px solid #c6daf2;color:#2c4a6e;display:flex;font-size:1.4rem;gap:.8rem;line-height:1.35;margin:0 0 1.5rem;padding:1.1rem 1.4rem}.free-shipping-notice i[data-v-0ae98987]{color:#3f73b3;flex:0 0 auto}", ""]);

// exports
